import { createElement as rc, useState, useId } from 'react';
import { Button, View, ScrollView, GestureRecognizer, styled, webOnlyStyles } from 'lib_ui-primitives';
import { Content } from './styles';

const Summary = styled(View)`
    flex-direction: column;
    width: 100%;
    gap: 8px;
`;

const DetailsViewport = webOnlyStyles(styled(View)`
    width: 100%;
    height: 240px;
    flex-grow: 0;
`)`max-height: 40vh;`;

const DetailList = styled(ScrollView)`
    width: 100%;
    height: 100%;
`;

const DetailRow = styled(View)`
    flex-direction: column;
    flex-shrink: 0;
    padding: 8px 0;
`;

const statusLabels = {
    waiting: 'Waiting',
    receiving: 'Receiving records',
    deleting: 'Processing deletions',
    complete: 'Complete',
    failed: 'Failed'
};

export default function SyncProgressDetails({ collections }) {
    const [expanded, setExpanded] = useState(false);
    const detailsId = useId();
    const rows = Object.values(collections);
    const complete = rows.filter(row => row.status === 'complete').length;

    // prettier-ignore
    return rc(Summary, null,
        rc(Content, null, `${complete} of ${rows.length} collections complete`),
        rc(Button, {
            value: expanded ? 'Hide details' : 'Show details',
            buttonStyle: 'link',
            'aria-expanded': expanded,
            'aria-controls': detailsId,
            onClick: () => setExpanded(value => !value)
        }),
        expanded && rc(DetailsViewport, null,
            rc(GestureRecognizer, null,
                rc(DetailList, { id: detailsId, role: 'list', 'aria-label': 'Sync collections' },
                    rows.map(row => rc(DetailRow, { key: row.key, role: 'listitem', 'aria-label': row.title },
                        rc(Content, null, `${row.title}: ${statusLabels[row.status]}`),
                        rc(Content, null, `${formatCount(row.recordsReceived, 'record')} received`)
                    ))
                )
            )
        )
    );
}

function formatCount(count, noun) {
    return `${count.toLocaleString('en-US')} ${noun}${count === 1 ? '' : 's'}`;
}
